import React, { useContext, useState } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import ViewOfferSubTabs from "./ViewOfferSubTabs";
import { VIEW_OFFER_TABS } from "./constants/initialValues";
import { ViewOfferContext } from "./context";
import ViewOfferUsageList from "./ViewOfferUsageList";

const ViewOfferUsage = ({activeTab, setActiveTab}) => {
  const { values } = useContext(ViewOfferContext);

  return (
    <CardBody>
      {values?.recurringUsageRatePlan?.length === 0 ? (
        <div className="text-center">No Usage Rate Plans</div>
      ) : (
        values?.recurringUsageRatePlan?.map((usage, index) => (
          <ViewOfferUsageList
            index={index}
            usage={usage}
            activeTab={activeTab}
          />
        ))
      )}
    </CardBody>
  );
};

export default ViewOfferUsage;
